import React, { useContext } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { context } from '@/Layout'

const fadeVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: [0, 0.71, 0.2, 1.01],
    },
  },
  out: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0, 0.71, 0.2, 1.01],
    },
  },
}

const RenderImgHeader = ({ link }) => {
  const { appState } = useContext(context)
  const menusHeader = get(appState, ['menus', 'main-menu'], [])
  const lisnkSelected = menusHeader.find((item) => item.url === `${window.location.origin}${link}`)
  const imgheader = get(lisnkSelected, ['acf', 'menu_image'], '')
  const defaultImg = get(menusHeader[0], ['acf', 'menu_image'], '')

  if (lisnkSelected) {
    return (
      <AnimatePresence>
        <motion.img
          key={imgheader.url} // La clave es importante para el manejo correcto de la animación de entrada/salida
          src={imgheader.url}
          variants={fadeVariants} // Utilizando el objeto de variants
          initial="initial"
          animate="in"
          exit="out"
          className="h-full w-full"
        />
      </AnimatePresence>
    )
  }

  return (
    <AnimatePresence>
      <motion.img
        key={defaultImg.url} // La clave es importante para el manejo correcto de la animación de entrada/salida
        src={defaultImg.url}
        variants={fadeVariants} // Utilizando el objeto de variants
        initial="initial"
        animate="in"
        exit="out"
        className="h-full w-full"
      />
    </AnimatePresence>
  )
}

RenderImgHeader.propTypes = {
  link: PropTypes.string,
}

export default RenderImgHeader
